import React from 'react';

import artwork from '../../../../Assets/Linkages/SpaceOutreachFilm/Film-at-a-Glance-Artwork.png';

const filmDetails = [
  ['Genre', 'Sci-fi / Drama'],
  ['Duration', '38 mins'],
  ['Language', 'Urdu (English subtitles)'],
  ['Audience', 'Academia, Youth, Activists, Public'],
  ['Cast', 'Amna Ilyas, Ghulam Mohiuddin, Daniyal Raheal'],
];

const FilmAtGlance = () => (
  <section className="film-at-glance" aria-labelledby="film-at-glance-title">
    <div className="film-at-glance-inner">
      <div className="film-at-glance-copy">
        <p className="section-eyebrow">THE STORY IN FOCUS</p>
        <h2 id="film-at-glance-title">Film at a Glance</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />

        <dl className="film-at-glance-details">
          {filmDetails.map(([label, value]) => (
            <div className="film-at-glance-detail" key={label}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>

        <a
          className="outreach-film-trailer-link"
          href="https://www.youtube.com/watch?v=3xKxM2Czg5s"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Watch Jahan Aur Bhi Hain on YouTube"
        >
          Watch Telefilm <span aria-hidden="true">→</span>
        </a>
      </div>

      <figure className="film-at-glance-artwork">
        <img src={artwork} alt="Jahan Aur Bhi Hain film artwork" loading="lazy" />
      </figure>
    </div>
  </section>
);

export default FilmAtGlance;
